import React, { useState } from "react";
import moment from "moment";
import * as RB from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

function View(props) {
  const { rowData } = props;
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const navigate = useNavigate();
  const getSafeValue = (value) =>
    value && value !== "undefined" && value !== null && value !== ""
      ? value
      : "-";

  // ✅ File preview helper
  const getFilePreview = (doc) => {
    if (doc.branding_image.match(/\.(jpg|jpeg|png|gif)$/i)) {
      return (
        <img
          src={doc.attachPath}
          alt={doc.branding_image}
          className="img-fluid rounded"
          style={{ maxHeight: "120px", objectFit: "cover" }}
        />
      );
    } else if (doc.branding_image.endsWith(".pdf")) {
      return (
        <i className="material-icons-outlined md-64 text-danger">
          picture_as_pdf
        </i>
      );
    } else if (
      doc.branding_image.endsWith(".doc") ||
      doc.branding_image.endsWith(".docx")
    ) {
      return (
        <i className="material-icons-outlined md-64 text-primary">
          description
        </i>
      );
    } else if (
      doc.branding_image.endsWith(".xls") ||
      doc.branding_image.endsWith(".xlsx")
    ) {
      return (
        <i className="material-icons-outlined md-64 text-success">
          table_chart
        </i>
      );
    } else if (
      doc.branding_image.endsWith(".ppt") ||
      doc.branding_image.endsWith(".pptx")
    ) {
      return (
        <i className="material-icons-outlined md-64 text-warning">slideshow</i>
      );
    }
    return (
      <i className="material-icons-outlined md-64 text-secondary">
        insert_drive_file
      </i>
    );
  };

  const handleShowModal = (text) => {
    setModalContent(text);
    setShowModal(true);
  };
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  queryParams.delete("id");

  const handleBackClick = () => {
    queryParams.delete("id");
    if (props.ismyBranding) {
      navigate("marketing/my-branding/");
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">View Branding Details</h5>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>

        <RB.Card.Body>
          <RB.Row className="mb-3">
            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                Counter
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.dealership_name || rowData.counter)}
              </p>
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                State
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.state_name || rowData.state)}
              </p>
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                District
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.district_name || rowData.district)}
              </p>
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                City
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.city_name || rowData.city)}
              </p>
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                Subject
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.subject)}
              </p>
            </RB.Col>

            {/* ✅ Subject Detail with ellipsis + modal */}
            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                Subject Detail
              </span>
              {rowData.subject_detail && rowData.subject_detail.length > 60 ? (
                <p
                  className="fw-medium text-sm fw-semibold text-truncate"
                  style={{
                    maxWidth: "100%",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title="Click to view full details"
                  onClick={() => handleShowModal(rowData.subject_detail)}
                >
                  {rowData.subject_detail}
                </p>
              ) : (
                <p className="fw-medium text-sm fw-semibold">
                  {getSafeValue(rowData.subject_detail)}
                </p>
              )}
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                Counter Key Person
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {getSafeValue(rowData.emp_name || rowData.counterKeyPerson)}
              </p>
            </RB.Col>

            <RB.Col md={4}>
              <span className="text-uppercase fw-bold small text-body-secondary">
                Total Amount
              </span>
              <p className="fw-medium text-sm fw-semibold">
                {rowData.total_amt ? Number(rowData.total_amt).toFixed(2) : "-"}
              </p>
            </RB.Col>
          </RB.Row>

          {/* ✅ Document Section */}
          {rowData.document && rowData.document.length > 0 && (
            <>
              <h6 className="mt-2">Branding Documents</h6>
              <RB.Row className="mt-2 g-3">
                {rowData.document.map((doc, index) => (
                  <RB.Col key={index} md={6} lg={4}>
                    <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                      <div className="product-doc-upload">
                        <a
                          href={doc.attachPath}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none text-dark"
                        >
                          {getFilePreview(doc)}
                          <div className="text-truncate mt-2">
                            {doc.branding_image}
                          </div>
                        </a>
                      </div>
                    </div>
                  </RB.Col>
                ))}
              </RB.Row>
            </>
          )}
        </RB.Card.Body>
      </RB.Card>

      {/* ✅ Subject Detail Modal */}
      <RB.Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Subject Detail</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          <p className="mb-0">{modalContent}</p>
        </RB.Modal.Body>
      </RB.Modal>
    </div>
  );
}

export default View;
